<template>
  <CardItem :show-top-bar="false">
    <TextTitle>
      <template #icon>
        <a-icon type="lock" />
      </template>
      {{ computedPwd.title }}
    </TextTitle>
    <a-form
        :form="form"
        class="flex flex-grow flex-col justify-between"
        @submit="onCheckPassword"
    >
      <a-form-item
          :validate-status="passwordError() ? 'error' : ''"
          :help="passwordError() || ''"
      >
        <a-input-password
            :placeholder="computedPwd.placeholder"
            ref="input"
            size="large"
            class="input-password"
            v-decorator="['password', { rules: [{ required: true, message: computedPwd.errorMsg ? computedPwd.errorMsg : ' ' }] }]"
        />
      </a-form-item>
      <a-form-item style="margin: 0">
        <a-button
            type="primary"
            html-type="submit"
            class="btn-action-primary"
            :style="[buttonBgColor, buttonTextColor]"
            :disabled="hasErrors(form.getFieldsError())"
            :loading="isLoading"
        >
          {{ computedPwd.buttonText }}
        </a-button>
      </a-form-item>
    </a-form>
  </CardItem>
</template>

<script>
import hasErrors from "@/helpers/formValidate";
import {mapGetters} from 'vuex';
import CardItem from "../CardItem";
import themeMixin from "../../mixins/theme.mixin";
import TextTitle from "../TextTitle";
import {isCreatorMode, isMobile} from "../../helpers/fns";

export default {
  name: "ScreenPassword",
  components: {CardItem, TextTitle},
  mixins: [themeMixin],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasErrors,
      form: this.$form.createForm(this, {name: 'survey_password_form'}),
    }
  },
  mounted() {
    document.title = this.computedPwd.title;

    this.$nextTick(() => {
      this.form.validateFields();
      if (!isMobile() && !isCreatorMode) {
        this.$refs.input?.focus();
      }
    });
  },
  computed: {
    ...mapGetters(['survey', 'error']),
    computedPwd() {
      const t = (
          this.error?.data?.translations?.surveyPassword ||
          this.survey?.translations?.surveyPassword // for creator mode
      );

      return {
        title: t?.title?.value || t?.title?.defaultValue,
        placeholder: t?.placeholder?.value,
        buttonText: t?.buttonSubmit?.value || t?.buttonSubmit?.defaultValue,
        errorMsg: this.error?.type === 'WRONG_PASSWORD' ? t?.error?.value || t?.error?.defaultValue : '',
      }
    }
  },
  methods: {
    passwordError() {
      const {getFieldError, isFieldTouched} = this.form;
      return this.computedPwd.errorMsg || (isFieldTouched('password') && getFieldError('password'));
    },
    onCheckPassword(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', values?.password);
        }
      });
    },
  }
}
</script>
